import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modal: {
    opened: false,
  }
};

export const assistant = createSlice({
  name: 'assistant',
  initialState,
  reducers: {
    startAssistantConversation: (state) => {
      state.modal.opened = true;
    },

    endAssistantConversation: (state) => {
      state.modal.opened = false;
    }
  }
});

export const {
  startAssistantConversation, endAssistantConversation
} = assistant.actions;

export default assistant.reducer;
